/* eslint-disable */
import { AssetIdentifier } from '../../../../spotify/catalogmanagement/entity/v1/asset';

export interface EntityIdentifier {
  /**
   *  The id of the entity - typically a Spotify URI
   */
  id: string;
  type: EntityType;
}

export interface EntityAndAssetIdentifier {
  entityId: EntityIdentifier | undefined;
  assetId: AssetIdentifier | undefined;
}

/**
 *  New Entity Data Model
 */
export interface BaseEntity {
  entityId: string;
  entityType: EntityType;
}

const baseEntityIdentifier: object = {
  id: '',
  type: 0,
};

const baseEntityAndAssetIdentifier: object = {};

const baseBaseEntity: object = {
  entityId: '',
  entityType: 0,
};

export const protobufPackage = 'spotify.catalogmanagement.entity.v1';

/**  init version copied from https://ghe.spotify.net/catalog-management/case-management-proto/blob/master/src/main/resources/spotify/casemanagement/v1/lead.proto
 */
export enum EntityType {
  UNKNOWN_ENTITY_TYPE = 0,
  /** SHOW -  for Content
   */
  SHOW = 1,
  EPISODE = 2,
  ALBUM = 3,
  TRACK = 4,
  PLAYLIST = 5,
  ARTIST = 6,
  /** PODCAST_SHORT -  Podcast Shorts have been discontinued
   */
  PODCAST_SHORT = 7,
  /** CREATOR_CHANNEL -  Podcast Shorts have been discontinued
   */
  CREATOR_CHANNEL = 8,
  AUDIOBOOK = 9,
  ANCHOR_URL = 10,
  ROOM = 17,
  ARTIST_EXPRESSION = 18,
  ALBUM_PRERELEASE_EXPRESSION = 19,
  AUDIOBOOK_CHAPTER = 20,
  QUESTION = 21,
  POLL = 22,
  RESPONSE = 23,
  CANVAS = 24,
  MERCH = 26,
  COMMENT = 27,
  /** EXPRESSION -  We will not use expression as a generic type
   */
  EXPRESSION = 28,
  PODCAST_THUMBNAIL = 29,
  CHAT_MESSAGE = 30,
  PODCAST_EXTERNAL_TRANSCRIPT = 31,
  SUPPLEMENTARY_MATERIAL = 32,
  EPISODE_VIDEO_PREVIEW = 33,
  AUDIOBOOK_AUTHOR = 34,
  COURSE = 35,
  LESSON = 36,
  WRAPPED_PARTY = 37,
  KALLAX = 38,
  PLAYLIST_V2 = 39,
  CHAT = 40,
  CLIP = 41,
  CONTRIBUTION_NOTE = 42,
  CHAPTER = 43,
  /** CONTENT_PROVIDER -  for Actor
   */
  CONTENT_PROVIDER = 11,
  USER = 12,
  GREENROOM_USER = 13,
  LICENSOR = 14,
  UGC_GENERATORS = 15,
  ADVERTISERS = 16,
  ACTOR = 25,
}

export function entityTypeFromJSON(object: any): EntityType {
  switch (object) {
    case 0:
    case 'UNKNOWN_ENTITY_TYPE':
      return EntityType.UNKNOWN_ENTITY_TYPE;
    case 1:
    case 'SHOW':
      return EntityType.SHOW;
    case 2:
    case 'EPISODE':
      return EntityType.EPISODE;
    case 3:
    case 'ALBUM':
      return EntityType.ALBUM;
    case 4:
    case 'TRACK':
      return EntityType.TRACK;
    case 5:
    case 'PLAYLIST':
      return EntityType.PLAYLIST;
    case 6:
    case 'ARTIST':
      return EntityType.ARTIST;
    case 7:
    case 'PODCAST_SHORT':
      return EntityType.PODCAST_SHORT;
    case 8:
    case 'CREATOR_CHANNEL':
      return EntityType.CREATOR_CHANNEL;
    case 9:
    case 'AUDIOBOOK':
      return EntityType.AUDIOBOOK;
    case 10:
    case 'ANCHOR_URL':
      return EntityType.ANCHOR_URL;
    case 17:
    case 'ROOM':
      return EntityType.ROOM;
    case 18:
    case 'ARTIST_EXPRESSION':
      return EntityType.ARTIST_EXPRESSION;
    case 19:
    case 'ALBUM_PRERELEASE_EXPRESSION':
      return EntityType.ALBUM_PRERELEASE_EXPRESSION;
    case 20:
    case 'AUDIOBOOK_CHAPTER':
      return EntityType.AUDIOBOOK_CHAPTER;
    case 21:
    case 'QUESTION':
      return EntityType.QUESTION;
    case 22:
    case 'POLL':
      return EntityType.POLL;
    case 23:
    case 'RESPONSE':
      return EntityType.RESPONSE;
    case 24:
    case 'CANVAS':
      return EntityType.CANVAS;
    case 26:
    case 'MERCH':
      return EntityType.MERCH;
    case 27:
    case 'COMMENT':
      return EntityType.COMMENT;
    case 28:
    case 'EXPRESSION':
      return EntityType.EXPRESSION;
    case 29:
    case 'PODCAST_THUMBNAIL':
      return EntityType.PODCAST_THUMBNAIL;
    case 30:
    case 'CHAT_MESSAGE':
      return EntityType.CHAT_MESSAGE;
    case 31:
    case 'PODCAST_EXTERNAL_TRANSCRIPT':
      return EntityType.PODCAST_EXTERNAL_TRANSCRIPT;
    case 32:
    case 'SUPPLEMENTARY_MATERIAL':
      return EntityType.SUPPLEMENTARY_MATERIAL;
    case 33:
    case 'EPISODE_VIDEO_PREVIEW':
      return EntityType.EPISODE_VIDEO_PREVIEW;
    case 34:
    case 'AUDIOBOOK_AUTHOR':
      return EntityType.AUDIOBOOK_AUTHOR;
    case 35:
    case 'COURSE':
      return EntityType.COURSE;
    case 36:
    case 'LESSON':
      return EntityType.LESSON;
    case 37:
    case 'WRAPPED_PARTY':
      return EntityType.WRAPPED_PARTY;
    case 38:
    case 'KALLAX':
      return EntityType.KALLAX;
    case 39:
    case 'PLAYLIST_V2':
      return EntityType.PLAYLIST_V2;
    case 40:
    case 'CHAT':
      return EntityType.CHAT;
    case 41:
    case 'CLIP':
      return EntityType.CLIP;
    case 42:
    case 'CONTRIBUTION_NOTE':
      return EntityType.CONTRIBUTION_NOTE;
    case 43:
    case 'CHAPTER':
      return EntityType.CHAPTER;
    case 11:
    case 'CONTENT_PROVIDER':
      return EntityType.CONTENT_PROVIDER;
    case 12:
    case 'USER':
      return EntityType.USER;
    case 13:
    case 'GREENROOM_USER':
      return EntityType.GREENROOM_USER;
    case 14:
    case 'LICENSOR':
      return EntityType.LICENSOR;
    case 15:
    case 'UGC_GENERATORS':
      return EntityType.UGC_GENERATORS;
    case 16:
    case 'ADVERTISERS':
      return EntityType.ADVERTISERS;
    case 25:
    case 'ACTOR':
      return EntityType.ACTOR;
    default:
      throw new globalThis.Error('Unrecognized enum value ' + object + ' for enum EntityType');
  }
}

export function entityTypeToJSON(object: EntityType): string {
  switch (object) {
    case EntityType.UNKNOWN_ENTITY_TYPE:
      return 'UNKNOWN_ENTITY_TYPE';
    case EntityType.SHOW:
      return 'SHOW';
    case EntityType.EPISODE:
      return 'EPISODE';
    case EntityType.ALBUM:
      return 'ALBUM';
    case EntityType.TRACK:
      return 'TRACK';
    case EntityType.PLAYLIST:
      return 'PLAYLIST';
    case EntityType.ARTIST:
      return 'ARTIST';
    case EntityType.PODCAST_SHORT:
      return 'PODCAST_SHORT';
    case EntityType.CREATOR_CHANNEL:
      return 'CREATOR_CHANNEL';
    case EntityType.AUDIOBOOK:
      return 'AUDIOBOOK';
    case EntityType.ANCHOR_URL:
      return 'ANCHOR_URL';
    case EntityType.ROOM:
      return 'ROOM';
    case EntityType.ARTIST_EXPRESSION:
      return 'ARTIST_EXPRESSION';
    case EntityType.ALBUM_PRERELEASE_EXPRESSION:
      return 'ALBUM_PRERELEASE_EXPRESSION';
    case EntityType.AUDIOBOOK_CHAPTER:
      return 'AUDIOBOOK_CHAPTER';
    case EntityType.QUESTION:
      return 'QUESTION';
    case EntityType.POLL:
      return 'POLL';
    case EntityType.RESPONSE:
      return 'RESPONSE';
    case EntityType.CANVAS:
      return 'CANVAS';
    case EntityType.MERCH:
      return 'MERCH';
    case EntityType.COMMENT:
      return 'COMMENT';
    case EntityType.EXPRESSION:
      return 'EXPRESSION';
    case EntityType.PODCAST_THUMBNAIL:
      return 'PODCAST_THUMBNAIL';
    case EntityType.CHAT_MESSAGE:
      return 'CHAT_MESSAGE';
    case EntityType.PODCAST_EXTERNAL_TRANSCRIPT:
      return 'PODCAST_EXTERNAL_TRANSCRIPT';
    case EntityType.SUPPLEMENTARY_MATERIAL:
      return 'SUPPLEMENTARY_MATERIAL';
    case EntityType.EPISODE_VIDEO_PREVIEW:
      return 'EPISODE_VIDEO_PREVIEW';
    case EntityType.AUDIOBOOK_AUTHOR:
      return 'AUDIOBOOK_AUTHOR';
    case EntityType.COURSE:
      return 'COURSE';
    case EntityType.LESSON:
      return 'LESSON';
    case EntityType.WRAPPED_PARTY:
      return 'WRAPPED_PARTY';
    case EntityType.KALLAX:
      return 'KALLAX';
    case EntityType.PLAYLIST_V2:
      return 'PLAYLIST_V2';
    case EntityType.CHAT:
      return 'CHAT';
    case EntityType.CLIP:
      return 'CLIP';
    case EntityType.CONTRIBUTION_NOTE:
      return 'CONTRIBUTION_NOTE';
    case EntityType.CHAPTER:
      return 'CHAPTER';
    case EntityType.CONTENT_PROVIDER:
      return 'CONTENT_PROVIDER';
    case EntityType.USER:
      return 'USER';
    case EntityType.GREENROOM_USER:
      return 'GREENROOM_USER';
    case EntityType.LICENSOR:
      return 'LICENSOR';
    case EntityType.UGC_GENERATORS:
      return 'UGC_GENERATORS';
    case EntityType.ADVERTISERS:
      return 'ADVERTISERS';
    case EntityType.ACTOR:
      return 'ACTOR';
    default:
      return 'UNKNOWN';
  }
}

export const EntityIdentifier = {
  fromJSON(object: any): EntityIdentifier {
    const message = { ...baseEntityIdentifier } as EntityIdentifier;
    if (object.id !== undefined && object.id !== null) {
      message.id = String(object.id);
    } else {
      message.id = '';
    }
    if (object.type !== undefined && object.type !== null) {
      message.type = entityTypeFromJSON(object.type);
    } else {
      message.type = 0;
    }
    return message;
  },
  fromPartial(object: DeepPartial<EntityIdentifier>): EntityIdentifier {
    const message = { ...baseEntityIdentifier } as EntityIdentifier;
    if (object.id !== undefined && object.id !== null) {
      message.id = object.id;
    } else {
      message.id = '';
    }
    if (object.type !== undefined && object.type !== null) {
      message.type = object.type;
    } else {
      message.type = 0;
    }
    return message;
  },
  toJSON(message: EntityIdentifier): unknown {
    const obj: any = {};
    message.id !== undefined && (obj.id = message.id);
    message.type !== undefined && (obj.type = entityTypeToJSON(message.type));
    return obj;
  },
};

export const EntityAndAssetIdentifier = {
  fromJSON(object: any): EntityAndAssetIdentifier {
    const message = { ...baseEntityAndAssetIdentifier } as EntityAndAssetIdentifier;
    if (object.entityId !== undefined && object.entityId !== null) {
      message.entityId = EntityIdentifier.fromJSON(object.entityId);
    } else {
      message.entityId = undefined;
    }
    if (object.assetId !== undefined && object.assetId !== null) {
      message.assetId = AssetIdentifier.fromJSON(object.assetId);
    } else {
      message.assetId = undefined;
    }
    return message;
  },
  fromPartial(object: DeepPartial<EntityAndAssetIdentifier>): EntityAndAssetIdentifier {
    const message = { ...baseEntityAndAssetIdentifier } as EntityAndAssetIdentifier;
    if (object.entityId !== undefined && object.entityId !== null) {
      message.entityId = EntityIdentifier.fromPartial(object.entityId);
    } else {
      message.entityId = undefined;
    }
    if (object.assetId !== undefined && object.assetId !== null) {
      message.assetId = AssetIdentifier.fromPartial(object.assetId);
    } else {
      message.assetId = undefined;
    }
    return message;
  },
  toJSON(message: EntityAndAssetIdentifier): unknown {
    const obj: any = {};
    message.entityId !== undefined &&
      (obj.entityId = message.entityId ? EntityIdentifier.toJSON(message.entityId) : undefined);
    message.assetId !== undefined &&
      (obj.assetId = message.assetId ? AssetIdentifier.toJSON(message.assetId) : undefined);
    return obj;
  },
};

export const BaseEntity = {
  fromJSON(object: any): BaseEntity {
    const message = { ...baseBaseEntity } as BaseEntity;
    if (object.entityId !== undefined && object.entityId !== null) {
      message.entityId = String(object.entityId);
    } else {
      message.entityId = '';
    }
    if (object.entityType !== undefined && object.entityType !== null) {
      message.entityType = entityTypeFromJSON(object.entityType);
    } else {
      message.entityType = 0;
    }
    return message;
  },
  fromPartial(object: DeepPartial<BaseEntity>): BaseEntity {
    const message = { ...baseBaseEntity } as BaseEntity;
    if (object.entityId !== undefined && object.entityId !== null) {
      message.entityId = object.entityId;
    } else {
      message.entityId = '';
    }
    if (object.entityType !== undefined && object.entityType !== null) {
      message.entityType = object.entityType;
    } else {
      message.entityType = 0;
    }
    return message;
  },
  toJSON(message: BaseEntity): unknown {
    const obj: any = {};
    message.entityId !== undefined && (obj.entityId = message.entityId);
    message.entityType !== undefined && (obj.entityType = entityTypeToJSON(message.entityType));
    return obj;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | undefined;
type DeepPartial<T> = T extends Builtin
  ? T
  : T extends Array<infer U>
  ? Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U>
  ? ReadonlyArray<DeepPartial<U>>
  : T extends {}
  ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;
